<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>系統紀錄中心</b-breadcrumb-item>
            <b-breadcrumb-item active>Webhook Events</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div class="row">
        <h4 class="col-12 mb-4 font-weight-bold">
          {{ `【${organization.name}】Webhook Events` }}
        </h4>
      </div>

      <b-table
        striped
        hover
        responsive
        :items="webhookEvents"
        :fields="fields"
        :busy="isLoading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #cell(data)="row">
          <b-button
            v-if="row.item.data && formatData(row.item.data).length > 20"
            v-b-modal.modal-data-view
            class="flex-shrink-0 mr-2"
            variant=""
            @click="dataForFullView = row.item.data"
          >
            <span class="mdi mdi-arrow-expand-all"></span>
          </b-button>
          <span>{{ formatData(row.item.data) | hiddenString(20) }}</span>
        </template>
        <template #cell(is_forwarded)="data">
          {{ data.item.is_forwarded ? '是' : '否' }}
        </template>
        <template #cell(has_forwarded)="data">
          {{ data.item.has_forwarded ? '是' : '否' }}
        </template>
        <template #cell(created_at)="data">
          {{ formatDate(data.item.created_at) }}
        </template>
        <template #cell(updated_at)="data">
          {{ formatDate(data.item.updated_at) }}
        </template>
      </b-table>

      <CustomPagination
        :currentPage="query.page"
        :totalRows="total"
        :perPage="query.per_page"
        @page-change="handlePageChange"
        @per-page-change="handlePerPageChange"
      />
    </b-card>
    <b-modal id="modal-data-view" title="檢視完整 Data 內容">
      <JsonEditor
        height="400px"
        v-model="dataForFullView"
      />
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import webhookEventApi from "../../../apis/webhook-event";
import moment from "moment";
import JsonEditor from "@/components/Dashboard/JsonEditor";
import _ from "lodash";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import { mapGetters } from "vuex";
import { updateQueryFromRoute, updateUrlWithoutReload } from "@/utils/updateUrl";

export default {
  components: {
    JsonEditor,
    CustomPagination,
  },
  mixins: [paginationMixin],
  data() {
    return {
      isLoading: false,
      webhookEvents: [],
      dataForFullView: null,
      fields: [
        {
          key: "type",
          label: "Type",
        },
        {
          key: "outer_code",
          label: "Outer Code",
        },
        {
          key: "data",
          label: "Data",
        },
        {
          key: "is_forwarded",
          label: "Is Forwarded",
        },
        {
          key: "has_forwarded",
          label: "Has Forwarded",
        },
        {
          key: "created_at",
          label: "建立時間",
        },
        {
          key: "updated_at",
          label: "更新時間",
        },
      ],
      total: 0,
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
      },
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters("route", ["routeQuery"]),
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrlWithoutReload(this.query, this.$store, this.$router);
      },
    },
    routeQuery() {
      if (!this.initialized) return;
      this.fetchWebhookEvents();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  async mounted() {
    await this.fetchWebhookEvents();
    this.initialized = true;
  },
  methods: {
    async fetchWebhookEvents() {
      try {
        this.isLoading = true;
        const cleanedQuery = _.omitBy(this.query, _.isNil);
        const { data } = await webhookEventApi.getWebhookEvents(cleanedQuery);
        this.total = data.meta.total;
        this.webhookEvents = data.data;
      } catch (error) {
        console.log("");
      }
      this.isLoading = false;
    },
    formatData(value) {
      if (typeof value === "string") return value;
      return JSON.stringify(value);
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm");
      }
    },
  },
};
</script>
